export const ActionSeverity = Object.freeze({
  low: 'LOW',
  medium: 'MEDIUM',
  high: 'HIGH',
});

export const ActionSeverityToColor = Object.freeze({
  [ActionSeverity.low]: 'green',
  [ActionSeverity.medium]: 'warning',
  [ActionSeverity.high]: 'danger',
});
